export const addNairaSign = (amount: string | number | undefined) => {
  if (typeof amount === 'undefined') {
    return '₦0';
  }
  const newAmount = amount.toString().replace(/[,₦]/, '');

  return `₦${Number(newAmount).toLocaleString()}`;
};

export const removeComma = (amount: string | number) => {
  const formattedAmount = removeLetters(amount.toString());
  const newAmount = formattedAmount.toString().replace(/[,₦]/g, '');
  return newAmount;
};

export const removeLetters = (value: string) => {
  return value.replace(/[^0-9]/g, '');
};
